<!-- =========================================================================================
    File Name: Invoice.vue
    Description: Invoice Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="invoice-page">
        <vx-card title="Header" code-toggler>

            <p>

                La Universidad Politécnica Bicentenario te da la bienvenida y te felicita por este nuevo logro<br/>
                <br/>
                Para que puedas continuar con tu trámite de inscripción deberás acceder al este sistema de acuerdo a las siguientes fechas:<br/><br/>





               </p>

            <div class="demo-alignment">

                <vs-list>
                    <vs-list-header title="26 DE AGOSTO 2020"></vs-list-header>
                    <vs-list-item title="ING EN LOGÍSTICA Y TRANSPORTE" subtitle=""></vs-list-item>
                    <vs-list-item title="INGENIERIA BIOMEDICA" subtitle=""></vs-list-item>

                    <vs-list-header title="27 DE AGOSTO 2020" color="success"></vs-list-header>
                    <vs-list-item title="ING RÓBOTICA" subtitle=""></vs-list-item>
                    <vs-list-item title="ING. EN DISEÑO INDUSTRIAL " subtitle=""></vs-list-item>

                    <vs-list-header title="28 DE AGOSTO 2020"></vs-list-header>
                    <vs-list-item title="INGENIERÍA EN AGROTECNOLOGÍA" subtitle=""></vs-list-item>
                    <vs-list-item title="INGENIERIA FINANCIERA" subtitle=""></vs-list-item>
                </vs-list>

            </div>

            <template slot="codeContainer">
                &lt;vs-list&gt;
                &lt;vs-list-header title=&quot;Group 1&quot;&gt;&lt;/vs-list-header&gt;

                &lt;vs-list-item title=&quot;Snickerdoodle&quot; subtitle=&quot;An excellent companion&quot;&gt;&lt;/vs-list-item&gt;
                &lt;vs-list-item title=&quot;Sapporo Haru&quot; subtitle=&quot;An excellent polish restaurant, quick delivery and hearty, filling meals&quot;&gt;&lt;/vs-list-item&gt;
                &lt;vs-list-header title=&quot;Group 2&quot; color=&quot;success&quot;&gt;&lt;/vs-list-header&gt;
                &lt;vs-list-item title=&quot;Enid&apos;s&quot; subtitle=&quot;At night a bar, during the day a delicious brunch spot.&quot;&gt;&lt;/vs-list-item&gt;
                &lt;vs-list-item title=&quot;Veronika Ossi&quot; subtitle=&quot;Has not watched anything recently&quot;&gt;&lt;/vs-list-item&gt;
                &lt;/vs-list&gt;
            </template>

        </vx-card>
    </div>
</template>

<script>

export default{
    data() {
        return {
            matricula: localStorage.getItem('id_alumno'),
            alumno_detalle: []
        }
    },
    computed: {

    },
    created() {
        this.getAlumno();


    },
    methods: {
        getAlumno() {
            this.$http.get("alumno_id/" + this.matricula).then(
                response => {
                    // console.log(response.data)
                    this.alumno_detalle = response.data.alumno;
                    console.log(this.alumno_detalle);

                },
                error => {
                    this.StepError(error);
                }
            );
        },
    },

    components: {}
}
</script>
